import { Toast, Toaster } from "@newsela/angelou";

import { useEffect } from "react";
import globalToasterRef from "@/base/globalToasterRef";
import AILoadingSpinner from "@/components/AIComponents/AILoadingSpinner";
import { useExportablesModalContext } from "@/components/AIComponents/ExportablesModal/ExportablesModalContext/useExportablesModalContext";
import ExportablesArticlePreview from "./ExportablesArticlePreview";
import {
  bodyWrapperCss,
  galleryPreviewWrapperCss,
  instructionsCss,
  loadingSpinnerWrapperCss,
  loadingWrapperCss,
} from "./ExportablesModalBody.styles";
import ExportablesTemplateGallery from "./ExportablesTemplateGallery";
import ExportablesTemplatePreview from "./ExportablesTemplatePreview";

interface ExportablesModalBodyProps {
  isStudent: boolean;
}

const ExportablesModalBody = ({ isStudent }: ExportablesModalBodyProps) => {
  const {
    isInAssignGraphicOrganizersExperiment,
    isLoading,
    showAssignmentWarning,
    setShowAssignmentWarning,
    templatesToAssign,
  } = useExportablesModalContext();

  const instructions = isStudent
    ? "Your teacher has assigned you the graphic organizers below, you can type directly into them. Closing this window before submitting will delete any progress."
    : `Select all the graphic organizers you want to add to the assignment. You can also individually download them as PDFs. (${templatesToAssign.length} selected)`;

  const showInstructions = isStudent || isInAssignGraphicOrganizersExperiment;

  useEffect(() => {
    if (showAssignmentWarning) {
      globalToasterRef.current?.displayToast({
        children:
          "You must select at least one graphic organizer to add to an assignment.",
        handleDismiss: () => setShowAssignmentWarning(false),
        showIcon: true,
        statusColor: Toast.statusColor.warning,
      });
    }
  }, [showAssignmentWarning]);

  return isLoading ? (
    <div css={loadingWrapperCss}>
      <AILoadingSpinner __cssFor={{ root: loadingSpinnerWrapperCss }} />
    </div>
  ) : (
    <div css={bodyWrapperCss}>
      <Toaster ref={globalToasterRef} />

      {showInstructions && <p css={instructionsCss}>{instructions}</p>}

      <div css={galleryPreviewWrapperCss(isStudent)}>
        {isStudent ? (
          <ExportablesArticlePreview />
        ) : (
          <ExportablesTemplateGallery />
        )}
        <ExportablesTemplatePreview isStudent={isStudent} />
      </div>
    </div>
  );
};

export default ExportablesModalBody;
